import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

import Distributors from "../../screens/Distributors";

import {
  fetchDistributors,
  pageSelected,
  ChangeStatus,
  DistributorDetailView,
} from "./action";

class DistributorProfileContainer extends Component {
  render() {
    return (
      <Distributors
        fetchDistributors={this.props.fetchDistributors}
        DistributorsList={this.props.DistributorsList}
        DistributorsCount={this.props.DistributorsCount}
        pageSelected={this.props.pageSelected}
        ChangeStatus={this.props.ChangeStatus}
        DistributorDetailView={this.props.DistributorDetailView}
        distributorDetail={this.props.distributorDetail}
        distributorStatus={this.props.distributorStatus}
      />
    );
  }
}

function bindAction(dispatch) {
  return {
    fetchDistributors: (value) => {
      dispatch(fetchDistributors(value));
    },
    pageSelected: (value) => {
      dispatch(pageSelected(value));
    },
    ChangeStatus: (value) => {
      dispatch(ChangeStatus(value));
    },
    DistributorDetailView: (value) => {
      dispatch(DistributorDetailView(value));
    },
  };
}

const mapStateToProps = (state) => {
  return {
    DistributorsList: state.DistributorReducer.DistributorsList,
    DistributorsCount: state.DistributorReducer.DistributorsCount,
    distributorDetail: state.DistributorReducer.distributorDetail,
    distributorStatus: state.DistributorReducer.distributorStatus,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(DistributorProfileContainer);
